import { useEffect } from "react";

export const useDeprecation = (message: string): void => {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      console.warn(message);
    }
  }, [message]);
};
